import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import {
  Button as UIButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { theme } from "$utils/theme/bataillog";

import { Text, Popin, Button } from "$components";

type Props = {
  opList: any[];
  productAddToOp: {
    product: { qtyAsked: number; warehouse: string };
    index: number;
  };
  resetProduct: () => void;
  validateProductAddToOp: any;
};

function ProductEdbAddOpPopin({
  opList,
  productAddToOp,
  resetProduct,
  validateProductAddToOp,
}: Props) {
  const classes = useStyles();
  const [openPopin, setOpenPopin] = useState(false);
  const [entrepot, setEntrepot] = useState(null);
  const warehouse = productAddToOp?.product?.warehouse;
  const filteredOps = opList.filter(
    (op) => !warehouse || op.entrepot._id === warehouse
  );

  useEffect(() => {
    setOpenPopin(productAddToOp !== null);
  }, [productAddToOp]);

  const togglePopin = (open: boolean) => {
    setOpenPopin(open);
    resetProduct();
  };

  const validate = () => {
    validateProductAddToOp(
      productAddToOp.product.qtyAsked,
      entrepot,
      productAddToOp.index
    );
    togglePopin(false);
  };

  return (
    <Popin
      containerClassName={classes.ProductPopin}
      customCloseAction={() => {
        if (resetProduct) resetProduct();
      }}
      openPopin={openPopin}
      toggleDrawer={togglePopin}
    >
      <Text type="h2">Ajouter à un OP</Text>
      <div>
        <Text className={classes.label}>Sélectionner un OP existant</Text>
        <FormControl variant="outlined" style={{ width: 400 }}>
          <InputLabel>Liste des OP</InputLabel>
          <Select
            onChange={(e: any) => setEntrepot(e.target.value)}
            label="Selectionner un OP existant"
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              // getContentAnchorEl has been removed in MUI v5
              // Instead, anchorOrigin and transformOrigin are used to control positioning
            }}
          >
            {filteredOps.map((op: any) => (
              <MenuItem
                key={op._id}
                value={op.entrepot.name}
              >{`${op.code} - ${op.entrepot.name}`}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className={classes.navigationStep}>
        <UIButton
          variant="outlined"
          style={{ textTransform: "none" }}
          onClick={() => togglePopin(false)}
        >
          Retour
        </UIButton>
        <Button onClick={() => validate()}>Ajouter à l&lsquo;OP</Button>
      </div>
    </Popin>
  );
}

export default ProductEdbAddOpPopin;

const useStyles = createUseStyles(() => ({
  ProductPopin: {
    minWidth: "959px !important",
    maxWidth: "959px !important",
    "& > div": {
      position: "relative",
    },
  },
  navigationStep: {
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    display: "block",
    marginBottom: theme.spacing(2),
  },
}));
